import { useQuery } from '@tanstack/react-query';

import fetcher from '../fetcher';

export type ThingsToDoResponse = {
	agreementPrinting: number;
	creditSimulation: number;
	disbursementPrinting: number;
	disbursementVerification: number;
	mpp: number;
	nap: number;
	ocr: number;
	pipelineGoLive: number;
	plakat: number;
	purchaseOrder: number;
	purchaseOrderExtend: number;
	spf: number;
	customerChecking: number;
	businessApproval: number;
	assignCca: number;
	creditAssign: number;
	slikAnalysis: number;
	creditApproval: number;
	praSurvey: number;
	requestSurvey: number;
	surveyApproval: number;
	visitReport: number;
	visitRejection: number;
	pipelineHotProspect: number;
};

export const getThingsToDo = () => {
	return fetcher<ThingsToDoResponse>({
		api: '/things-todo/get-things-to-do',
	});
};

export const useThingsToDo = () => {
	return useQuery({
		queryKey: ['getThingsToDo'],
		queryFn: () => getThingsToDo(),
	});
};
